<template>
  <div class="form_modal">
    <div class="work_calendar__modal" @click="closeSelect($event.target)">
      <span
        class="work_calendar__modal--close_btn"
        @click="cleanUpModal()">
        Cerrar
      </span>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Evento</div>
        <input
          class="work_calendar__modal--input work_calendar__input"
          type="text"
          v-model="new_task.title">
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Inicio</div>

        <div class="work_calendar__modal--inputs_container">
          <vue-timepicker
            class="data_card__info--select--time"
            style="margin:5px 0 !important; width: 53%;"
            format="hh:mm a"
            placeholder="10:00 am"
            v-model="selected_dates.start.time"
            :minute-interval="5"
            auto-scroll
            input-width="95%"
            hour-label="Horas" minute-label="mins" apm-label="AM/PM"
            close-on-complete
            hide-clear-button>
          </vue-timepicker>
          <date-picker
            class="work_calendar__modal--date_picker"
            v-model="selected_dates.start.date"
            type="date"
            name="date_in"
            :confirm="false"
            placeholder="Seleccionar fecha"
            format="DD/MM/YYYY">
          </date-picker>
        </div>
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Fin</div>

        <div class="work_calendar__modal--inputs_container">
          <vue-timepicker
            class="data_card__info--select--time"
            style="margin:5px 0 !important; width: 53%;"
            format="hh:mm a"
            v-model="selected_dates.finish.time"
            :minute-interval="5"
            auto-scroll
            input-width="95%"
            hour-label="Horas" minute-label="mins" apm-label="AM/PM"
            close-on-complete
            hide-clear-button>
          </vue-timepicker>
          <date-picker
            class="work_calendar__modal--date_picker"
            v-model="selected_dates.finish.date"
            type="date"
            :confirm="false"
            placeholder="Seleccionar fecha"
            format="DD/MM/YYYY">
          </date-picker>
        </div>
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Tipo</div>

        <div class="work_calendar__modal--select_input_container">
          <div class="work_calendar__modal--select_input work_calendar__input">

            <div
              class="work_calendar__modal--option" @click="choosing_type = !choosing_type">
              <span
                v-if="selected_type"
                class="work_calendar__modal--task_type_color"
                :style="'background-color:'+selected_type.color">
              </span>
              {{ selected_type.type || 'Seleccionar' }}
              <span style="position: absolute; right: 10px;" class="material-icons">
                {{ choosing_type ? 'expand_less' : 'expand_more' }}
              </span>
            </div>

            <div
              class="work_calendar__modal--option work_calendar__hover"
              v-for="task_type in task_types"
              v-if="choosing_type"
              @click="selectType(task_type)">
              <span
                class="work_calendar__modal--task_type_color"
                :style="'background-color: '+task_type.color">
              </span>
              {{ task_type.type }}
            </div>

          </div>
        </div>
      </div>

      <div class="work_calendar__modal--item_container" style="align-items: flex-start;">
        <div
          class="work_calendar__modal--title"
          style="padding-top: 12px;">
          Proveedor
        </div>

        <div class="work_calendar__modal--inputs_container" style="align-items: flex-start;">
          <div class="work_calendar__modal--select_input_container" style="width: 50%;">
            {{ selected_provider.name || 'Seleccionar' }}
            <div
              class="work_calendar__modal--select_input work_calendar__input"
              style="z-index: 1;">
              <div class="work_calendar__modal--option" @click="choosing_provider = !choosing_provider">
                {{ selected_provider.name || 'Seleccionar' }}
                <span style="position: absolute; top: 10px; right: 10px;" class="material-icons">
                  {{ choosing_provider ? 'expand_less' : 'expand_more' }}
                </span>
              </div>

              <div style="overflow-y: scroll; max-height: 150px;">
                <div
                  class="work_calendar__modal--option work_calendar__hover"
                  v-for="provider in providers"
                  v-if="choosing_provider"
                  @click="selectProvider(provider)">
                  {{ provider.attributes.name }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="work_calendar__input"
            style="width: 47%; max-height: 150px; padding: 0;"
            :style="selected_provider.provider_info.staff.length > 3 ? 'overflow-y: scroll' : ''"
            v-if="selected_provider && selected_provider.provider_info.staff.length > 0">

            <div
              class="work_calendar__modal--checkbox_option"
              v-for="staff in selected_provider.provider_info.staff"
              @click="toggleStaff(staff.id)">
              <v-checkbox
                class="work_calendar__modal--checkbox"
                color="blue"
                :input-value="new_task.staff.includes(staff.id)"
                hide-details>
              </v-checkbox>
              <span style="width: 80%;">{{ staff.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="work_calendar__modal--item_container" style="align-items: flex-start;">
        <div
          class="work_calendar__modal--title"
          style="margin-top: 12px;">
          Notas
        </div>
        <textarea
          class="work_calendar__modal--input work_calendar__input"
          style="height: 160px; resize: none; padding: 15px 12px;"
          wrap="hard"
          v-model="new_task.notes">
        </textarea>
      </div>

      <div
        class="work_calendar__modal--item_container"
        style="justify-content: flex-end; margin-bottom: 0;">
        <button
          class="faccess_button my-3"
          style="padding: 0 50px;"
          @click="sendTaskInfo()">
          Guardar
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  components: {
    VueTimepicker
  },
  props: ['providers', 'show'],
  data(){
    return {
      choosing_type: false,
      choosing_provider: false,
      selected_type: '',
      selected_provider: '',
      selected_dates: {
        start: { time: '12:00 pm', date: new Date() },
        finish: { time: '01:00 pm', date: new Date() }
      },
      new_task: {
        title: '',
        task_start: '',
        task_finish: '',
        task_type: '',
        provider_id: '',
        staff: [],
        notes: ''
      },
      task_types: [
        { type: 'Mantenimiento', color: '#D50B00' },
        { type: 'Inspecciones', color: '#2C9BE5' },
        { type: 'Simulacro', color: '#3CB679' },
        { type: 'Otro', color: '#F6BF26' }
      ]
    }
  },
  methods: {
    sendTaskInfo(){
      try {
        const start_datetime = this.selected_dates.start.date ? new Date(moment(this.selected_dates.start.date).format().split('T')[0]+' '+this.selected_dates.start.time) : '',
              finish_datetime = this.selected_dates.finish.date ? new Date(moment(this.selected_dates.finish.date).format().split('T')[0]+' '+this.selected_dates.finish.time) : ''

        if(!this.new_task.title){
          throw { message: 'El evento debe tener título' }
        } else if(!start_datetime || !finish_datetime){
          throw { message: 'El evento debe tener fechas de inicio y fin asignadas' }
        } else if(start_datetime > finish_datetime){
          throw { message: 'La fecha y hora de fin del evento debe ser posterior a la fecha de inicio' }
        } else if(!this.new_task.task_type){
          throw { message: 'El evento debe tener un tipo' }
        } else if(!this.new_task.provider_id){
          throw { message: 'El evento debe tener asignado un proveedor' }
        }

        this.new_task.task_start = start_datetime
        this.new_task.task_finish = finish_datetime
        this.$emit('create-task', this.new_task)
        this.cleanUpModal()

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    selectType(type){
      this.choosing_type = false
      this.selected_type = type
      this.new_task.task_type = type.type
    },

    selectProvider(provider){
      this.choosing_provider = false
      this.selected_provider = provider.attributes
      this.new_task.staff = this.new_task.provider_id == provider.id ? this.new_task.staff : []
      this.new_task.provider_id = provider.id
    },

    toggleStaff(staff_id){
      if(this.new_task.staff.includes(staff_id)){
        this.new_task.staff.splice(this.new_task.staff.indexOf(staff_id), 1)
      } else {
        this.new_task.staff.push(staff_id)
      }
    },

    closeSelect(target){
      if(target.classList[0] != 'work_calendar__modal--option' && target.classList[0] != 'material-icons'){
        this.choosing_provider = false
        this.choosing_type = false
      }
    },

    cleanUpModal(){
      this.$emit('close-modal')
      this.choosing_provider = false
      this.choosing_type = false
      this.selected_provider = ''
      this.selected_type = ''

      this.selected_dates = {
        start: { time: '12:00 pm', date: new Date()},
        finish: { time: '01:00 pm', date: moment().format().split('T')[0] }
      }

      this.new_task = {
        title: '',
        task_start: '',
        task_finish: '',
        task_type: '',
        provider_id: '',
        staff: [],
        notes: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/work_calendar/ModalTaskCreation.vue